/** ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 * MODULE: index.js
 * Author: SE EMK
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */
/* -------------------------------- Imports --------------------------------- */
import Vue from 'vue'
import Router from 'vue-router'

/* Pages */
/* General */
import Home from '@/components/Pages/Home'
import Contact from '@/components/Pages/Contact'
import Team from '@/components/Pages/Team'
import Project from '@/components/Pages/Project'
import Trainings from '@/components/Pages/Trainings'
import ViewTraining from '@/components/Pages/ViewTraining'
import Contribute from '@/components/Pages/Contribute'
import Redirect from '@/components/Pages/Redirect'

/* Topics */
import ListBestPracticeTopics from '@/components/Pages/ListBestPracticeTopics'
import ViewBestPracticeTopic from '@/components/Pages/ViewBestPracticeTopic'

/* Best Practices */
import ListBestPractices from '@/components/Pages/ListBestPractices'
import ViewBestPractice from '@/components/Pages/ViewBestPractice'

/* General Best Practices */
import ViewGeneralBestPractice from '@/components/Pages/ViewGeneralBestPractice'

/* International Alerts */
import ListInternationalAlerts from '@/components/Pages/ListInternationalAlerts'
import ViewInternationalAlert from '@/components/Pages/ViewInternationalAlert'

/* Covid-19 */
import ListCovid19s from '@/components/Pages/ListCovid19s'
import ViewCovid19 from '@/components/Pages/ViewCovid19'

/* Glossary */
import Glossary from '@/components/Pages/Glossary'

/* ------------------------------ Definitions ------------------------------- */
/* ------------------------------- Functions -------------------------------- */
const routes = [
  {
    path: '/',
    name: 'home',
    component: Home
  },
  {
    path: '/contact',
    name: 'contact',
    component: Contact
  },
  {
    path: '/team',
    name: 'team',
    component: Team
  },
  {
    path: '/project',
    name: 'project',
    component: Project
  },
  {
    path: '/trainings',
    name: 'trainings',
    component: Trainings
  },
  {
    path: '/trainings/:trainingId',
    name: 'view-training',
    component: ViewTraining
  },
  {
    path: '/contribute',
    name: 'contribute',
    component: Contribute
  },
  {
    path: '/r/:slug',
    name: 'redirect',
    component: Redirect
  },
  {
    path: '/topics',
    name: 'list-best-practice-topics',
    component: ListBestPracticeTopics
  },
  {
    path: '/topic/:bestPracticeTopicId',
    name: 'view-best-practice-topic',
    component: ViewBestPracticeTopic
  },
  {
    path: '/best-practices',
    name: 'list-best-practices',
    component: ListBestPractices
  },
  {
    path: '/best-practice/:bestPracticeId',
    name: 'view-best-practice',
    component: ViewBestPractice
  },
  {
    path: '/international-alerts',
    name: 'list-international-alerts',
    component: ListInternationalAlerts
  },
  {
    path: '/international-alert/:internationalAlertId',
    name: 'view-international-alert',
    component: ViewInternationalAlert
  },
  {
    path: '/covid-19s',
    name: 'list-covid-19s',
    component: ListCovid19s
  },
  {
    path: '/covid-19/:covid19Id',
    name: 'view-covid-19',
    component: ViewCovid19
  },
  {
    path: '/general-best-practice/:generalBestPracticeId',
    name: 'view-general-best-practice',
    component: ViewGeneralBestPractice
  },
  {
    path: '/glossary',
    name: 'glossary',
    component: Glossary
  }
]

/* --------------------------------- Body ----------------------------------- */
/* Add router to Vue.js */
Vue.use(Router)

/* -------------------------------- Exports --------------------------------- */
export default new Router({ routes: routes })



// WEBPACK FOOTER //
// ./src/router/index.js